import type { ReactElement, ReactNode } from 'react';
import styles from './EmptyState.module.scss';

export interface EmptyStateProps {
  title: ReactNode;
  text?: ReactNode;
  action?: ReactNode;
}

/** Пустое состояние экрана: что здесь будет и что сделать дальше. */
export function EmptyState({ title, text, action }: EmptyStateProps): ReactElement {
  return (
    <div className={styles.empty}>
      <p className={styles.title}>{title}</p>
      {text ? <p>{text}</p> : null}
      {action ? <div className="u-row">{action}</div> : null}
    </div>
  );
}
